import React from 'react'
import turfBbox from '@turf/bbox'
import StreetView from './Map/StreetView'

export default class MobilePopup extends React.Component {
    constructor(props) {
        super(props)

        this.state = { activeAPN: '', activeFeature: null, show: false, showStreetView: false }
    }

    componentDidUpdate({ activeAPN, activeFeature }) {
        if (activeAPN === this.props.activeAPN && activeFeature === this.props.activeFeature) {
            return
        }

        if (activeFeature === null && this.props.activeFeature !== null) {
            this.setState({ activeAPN: this.props.activeAPN, activeFeature: this.props.activeFeature })
            setTimeout(() => this.setState({ show: true }), 10)
        } else if (activeFeature !== null && this.props.activeFeature === null) {
            this.setState({ show: false })
            setTimeout(
                () => this.setState({ activeAPN: this.props.activeAPN, activeFeature: this.props.activeFeature }),
                1000
            )
        } else if (activeAPN !== this.props.activeAPN || activeFeature !== this.props.activeFeature) {
            this.setState({ activeAPN: this.props.activeAPN, activeFeature: this.props.activeFeature })
        }
    }

    render() {
        const { show, activeAPN, activeFeature, showStreetView } = this.state
        const { unselect, setActiveFeature, setPopupLocation, selectParcels, unselectParcel } = this.props

        return (
            <div className={`mobile-popup ${show ? 'show' : ''} ${showStreetView ? 'streetview' : ''}`}>
                <div>{showStreetView && activeFeature && <StreetView activeFeature={activeFeature} />}</div>
                {activeFeature !== null ? (
                    <div className="mobile-popup-inner">
                        <div className="parcel-popup">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>APN</td>
                                        <td className="has-text-weight-bold">{activeFeature.properties.parcel_apn}</td>
                                    </tr>
                                    <tr>
                                        <td>ADDRESS</td>
                                        <td className="has-text-weight-bold">
                                            <span>{activeFeature.properties.site_addr}</span>
                                            <br />
                                            <span>
                                                {activeFeature.properties.site_city}&nbsp;
                                                {activeFeature.properties.site_state}&nbsp;
                                                {activeFeature.properties.size_zip}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2">
                                            <a
                                                onClick={() =>
                                                    this.setState(state => ({ showStreetView: !state.showStreetView }))
                                                }
                                            >
                                                {showStreetView ? 'hide' : 'show'} street view
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="popup-buttons">
                            <div>
                                <button
                                    className="button is-neutral"
                                    onClick={() => {
                                        this.setState({ showStreetView: false })
                                        setActiveFeature(null)
                                        setPopupLocation(null)
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="button is-primary is-pulled-right"
                                    onClick={() => {
                                        if (unselect) {
                                            unselectParcel(activeAPN)
                                        } else {
                                            const { properties } = activeFeature

                                            selectParcels({
                                                id: properties.parcel_id,
                                                apn: activeAPN,
                                                county: properties.countyname.toLowerCase(),
                                                address: {
                                                    address: properties.site_addr,
                                                    city: properties.site_city,
                                                    zip: properties.site_zip,
                                                    state: 'CA',
                                                    label: `${properties.site_addr}, ${properties.site_city} ${properties.site_zip}`
                                                },
                                                bounds: turfBbox(activeFeature),
                                                mpo: properties.mpo,
                                                specific_plan: properties.specific_plan,
                                                census_block: properties.census_block.split(' ').pop(),
                                                zoning_designation: JSON.parse(properties.zoning_designation)
                                            })
                                        }
                                        this.setState({ showStreetView: false })
                                        setActiveFeature(null)
                                        setPopupLocation(null)
                                    }}
                                >
                                    {unselect ? 'Unselect' : 'Select'}
                                </button>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        )
    }
}
